<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between margin-bottom-sm list-title">
            <b>子账号管理</b>
            <span class="add-btn" @click="addItem(false)"
            >添加
            </span>
        </div>
        <div class="ship-list">
            <el-table :data="lists" border
                      header-row-class-name="table-header"
                      style="width: 100%; border-radius: 10px">
                <el-table-column label="姓名" prop="name">
                    <template slot-scope="scope">
                        <div class="flex justify-center"> {{ scope.row.name }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="账号" prop="phone">
                    <template slot-scope="scope">
                        <div class="flex justify-center">{{ scope.row.account }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="发展会员数量" prop="count">
                    <template slot-scope="scope">
                       <router-link class="flex justify-center" :to="`/organization/members/list?share_id=${scope.row.id}&t=${new Date().getTime()}`">
                           <el-link>{{ scope.row.share_num || 0 }}</el-link>
                       </router-link>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="300">
                    <template slot-scope="scope">
                        <div class="flex justify-center">
                            <el-button type="text" @click="addItem(scope.row)">编辑</el-button>
                            <span class="padding-lr-sm"></span>
                            <template v-if="isZch">
                                <el-button type="text" @click="shareItem(scope.row,0)">邀请链接</el-button>
                                <span class="padding-lr-sm"></span>
                                <el-button type="text" @click="shareItem(scope.row,2)">个人链接</el-button>
                                <span class="padding-lr-sm"></span>
                                <el-button type="text" @click="shareItem(scope.row,1)">单位链接</el-button>
                                <span class="padding-lr-sm"></span>
                            </template>
                            <el-button type="text" @click="itemPower(scope.row.id)">权限</el-button>
                            <span class="padding-lr-sm"></span>
                            <el-button style="color: red" type="text" @click="deleteItem(scope.row.id)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <add-admin-dialog :id="cur_id" :applyDialogVisible="applyDialogVisible" :info="cur_item"
                          @watchState="watchState"></add-admin-dialog>
    </div>
</template>

<script>
import {delSonAdmin, getSonAdmin} from '@/api/organiz'
import AddAdminDialog from "@/components/AddAdminDialog.vue";
import {HOSTPATH} from "@/config";
import {isZch} from "@/utils/rules";

export default {
    name: "serverList",
    data() {
        return {
            searchName: '',
            lists: [],
            cur_item: null,
            cur_id: 0,
            applyDialogVisible: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        isZch(){
            return isZch(this.user.mid)
        },
    },
    created() {
        this.$emit('setIndex', [5, 5], '子账号管理')
        this.init()
    },
    components: {AddAdminDialog},
    methods: {
        //  页面加载时请求
        async init() {
            let _data = await getSonAdmin(this.searchName)
            if (_data.status === 200) {
                this.lists = _data.data
                this.total = _data.count
            } else {
                this.lists = []
            }
        },
        addItem(data) {
            this.applyDialogVisible = true
            if (data) {
                this.cur_item = JSON.parse(JSON.stringify(data))
                this.cur_id = data.id
            } else {
                this.cur_item = null
                this.cur_id = 0
            }
        },
        itemPower(id) {
            this.$router.push('/organization/members/sonPower/' + id)
        },
        deleteItem(id) {
            this.$confirm("确定要删除该账号吗", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.delSonAdmin(id)
            })
        },
        async delSonAdmin(id) {
            let _data = await delSonAdmin(id)
            if (_data.status === 200) {
                this.init()
                this.$message.success(_data.msg)
            }
        },
        watchState(state) {
            if (state) this.init()
            this.applyDialogVisible = false;
        },
        shareItem(item,type) {
            let _link = `${HOSTPATH}invitation/${this.user.mid}?share_id=${item.id}${type ? `&user_type=${type}` : ''}`
            let oInput = document.createElement('input')
            oInput.value = _link
            document.body.appendChild(oInput)
            oInput.select() // 选择对象
            document.execCommand("Copy") // 执行浏览器复制命令
            oInput.className = 'oInput'
            oInput.style.display = 'none'
            this.$message({
                message: '复制网址成功',
                type: 'success'
            })
        }
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    background: #fff;
    border-radius: 10px;

    .list-title {
        b {
            font-size: 26px;
            line-height: 34px;
        }

        .add-btn {
            display: block;
            width: 200px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            font-size: 16px;
            color: #fff;
            cursor: pointer;
        }
    }
}
</style>
